import { Component, ViewChild, NgModule, Input, EventEmitter, Output, } from '@angular/core';
import { ImageUploadService } from '../../services/image-upload.service';
import { Configuration } from '../../../app.constants';
import { CommonModule } from '@angular/common';
import { HelperService } from '../../../shared/services/helper.service';
import{NamechangeformComponent}from'./../../../changerequest/components/namechange/namechangeform.component'
import{SubjectchangeformComponent}from'./../../../changerequest/components/subjectchange/subjectchangeform.component'
import{BranchchangeformComponent}from'./../../../changerequest/components/branchchange/branchchangeform.component';
import{CollegechangeformComponent}from'./../../../changerequest/components/collegechange/collegechangeform.component';
import{CenterchangeformComponent}from'./../../../changerequest/components/centerchange/centerchangeform.component';
import{ProvisionalmarksheetformComponent}from'./../../../changerequest/components/provisional-marksheet/provisionalmarksheetform.component';
import{DuplicateMarksheetformComponent}from'./../../../changerequest/components/duplicate-marksheet/duplicate-marksheetform.component';

@Component({
  selector: 'requestdocumentuploadother',
  templateUrl: './requestdocumentuploadother.component.html',
  styleUrls: ['./requestdocumentuploadother.component.scss'],
  providers:[NamechangeformComponent,SubjectchangeformComponent,BranchchangeformComponent,
            ProvisionalmarksheetformComponent,DuplicateMarksheetformComponent,
            CollegechangeformComponent,CenterchangeformComponent]
})
export class RequestdocumentuploadotherComponent {
  @Input()
  documentObject: any;

  @Output() fileUploadSuccess = new EventEmitter();
  @Output() fileUploadError = new EventEmitter();

  errorMessage: string;
  filesToUpload: Array<File>;
  selectedFileNames: string[] = [];
  public isLoadingData: Boolean = false;
  @ViewChild('fileUpload') fileUploadVar: any;
  uploadResult: any;
  res: Array<string>;
  constructor(private imageService: ImageUploadService,  
    private HelperService: HelperService,public configuration: Configuration, 
    private NamechangeformComponent:NamechangeformComponent,
    private SubjectchangeformComponent:SubjectchangeformComponent,
    private BranchchangeformComponent:BranchchangeformComponent,
    private CollegechangeformComponent:CollegechangeformComponent,
    private CenterchangeformComponent:CenterchangeformComponent,
    private ProvisionalmarksheetformComponent:ProvisionalmarksheetformComponent,
    private DuplicateMarksheetformComponent:DuplicateMarksheetformComponent,

    ) { 
      this.errorMessage = "";
    }

    fileChangeEvent(fileInput: any) {

    
      //Clear Uploaded Files result message
      this.uploadResult = "";
      //this.filesToUpload = <Array<File>>fileInput.target.files;
      this.filesToUpload = fileInput;
  
      for (let i = 0; i < this.filesToUpload.length; i++) {
        this.selectedFileNames.push(this.filesToUpload[i].name);
      }
    }
  
    cancelUpload() {
      this.filesToUpload = [];
      this.fileUploadVar.nativeElement.value = "";
      this.selectedFileNames = [];
      this.uploadResult = "";
      this.errorMessage = "";
    }
  
    upload() {
  
      if (this.filesToUpload.length == 0) {
       // alert('Please select at least 1 PDF files to upload!');
       this.HelperService.showWarningMessage("Please select at least 1 PDF files to upload!");
      }
      else if (this.filesToUpload.length > 3) {
        //alert('Please select a maximum of 3 PDF files to upload!');
        this.HelperService.showWarningMessage("Please select a maximum of 3 PDF files to upload!");
  
      }
      else {
        if (this.validatePDFSelectedOnly(this.selectedFileNames)) {
          // this.uploadFiles();
        }
      }
    }
  
    validatePDFSelectedOnly(filesSelected: string[]) {
      for (var i = 0; i < filesSelected.length; i++) {
        if (filesSelected[i].slice(-3).toUpperCase() != "PDF") {
          //alert('Please select PDF files only!');
          this.HelperService.showWarningMessage("Please select PDF files only!");
          return false;
        }
        else {
          return true;
        }
      }
    }
  
    uploadFiles(fileDocUpload: any) {
      this.uploadResult = "";
      if (fileDocUpload.length > 0) {
        this.isLoadingData = true;
  
        var studentDocumentData = this.documentObject.data;
  
  
        var data = {
          "StudentID": this.configuration.StudentID,
          "ApplicationNO":studentDocumentData.ApplicationNO,
          "ResultQueryCode":studentDocumentData.ResultQueryCode,
          "ExamInstanceID":this.configuration.ExamInstanceID,
        }
  
  
  
  
        this.imageService.uploadFilesForRequest(fileDocUpload[0], data).subscribe(
          data => {
            this.uploadResult = data;
            this.errorMessage = "";
            this.onSucces("Success");
            this.HelperService.showSuccessMessage("File uploaded successfully.");
            if(studentDocumentData.ResultQueryCode==5){
              this.BranchchangeformComponent.cancelClick();
            }
            if(studentDocumentData.ResultQueryCode==6){
              this.CollegechangeformComponent.cancelClick();
            }
            if(studentDocumentData.ResultQueryCode==7){
              this.CenterchangeformComponent.cancelClick();
            }
            if(studentDocumentData.ResultQueryCode==8){
              this.NamechangeformComponent.cancelClick();
            }
            if(studentDocumentData.ResultQueryCode==9){
              this.SubjectchangeformComponent.cancelClick();
            }
            if(studentDocumentData.ResultQueryCode==16){
              this.ProvisionalmarksheetformComponent.cancelClick();
            }
            if(studentDocumentData.ResultQueryCode==17){
              this.DuplicateMarksheetformComponent.cancelClick();
            }
          },
          err => {
            console.error(err);
            this.errorMessage = err;
            this.isLoadingData = false;
            this.onFailure("Failure");
            this.HelperService.showWarningMessage("File upload not successful.");
            this.documentObject.data.DocumentPath=0;
          },
          () => {
            this.isLoadingData = false,
              this.fileUploadVar.nativeElement.value = "";
            this.selectedFileNames = [];
            this.filesToUpload = [];
            this.onSucces("Success");
          })
      }
    }
  
    ngOnInit() {

      console.log(this.documentObject);
    }
  
    onClick() {
     // this.documentObject.data.DocumentPath=1;
       //  this.commonDocuments.showButtons=false;
    //  d.data.DocumentPath.length == 0 && showButtons
      const fileUpload = document.getElementById('file-upload') as HTMLInputElement;
      
     
      fileUpload.onchange = () => {
        
        for (let index = 0; index < fileUpload.files.length; index++) {
         const file = fileUpload.files[index];
          this.selectedFileNames.push(file.name);
        }
        if (fileUpload.files[0].size > this.configuration.FileUploadSize) {
          //alert("File Size Exceeds Max Allowed Size.");
          this.HelperService.showWarningMessage("File Size Exceeds Max Allowed Size.");
        }
        else {
          if (this.validatePDFSelectedOnly(this.selectedFileNames)) {
            this.uploadFiles(fileUpload.files);
          }
        }
  
      };
      fileUpload.click();
      
      fileUpload.onclose=(e)=>{
        alert("done");
      }
    }
  
    private onSucces(messageResponse: string) {
      this.fileUploadSuccess.emit(messageResponse);
    }
  
    private onFailure(messageResponse: string) {
      this.fileUploadError.emit('');
    }
  
  }

  @NgModule({
    imports: [
      CommonModule
    ],
    providers: [
      ImageUploadService,
      NamechangeformComponent,
      SubjectchangeformComponent
    ],
    exports: [
      RequestdocumentuploadotherComponent,
    ],
    declarations: [
      RequestdocumentuploadotherComponent
    ]
  })
  export class RequestdocumentuploadotherModule { }